export const dataMappingTour = {
    module: 'data_mapping',
    title: 'Data Mapping Tour',
    title_vi: 'Hướng dẫn Bản đồ dữ liệu',
    description: 'Explore Data Flows, Systems, Processing Activities, ROPA Completeness, Data Categories and the related workspaces. Read the screens and controls without submitting business changes.',
    description_vi: 'Tìm hiểu Luồng dữ liệu, Hệ thống, Hoạt động xử lý, Tính đầy đủ ROPA, Danh mục Dữ liệu và các không gian làm việc liên quan. Xem màn hình và điều khiển mà không gửi thay đổi nghiệp vụ.',
    estimated_duration_seconds: 530,
    revision: '2026-11-04.1',
    steps: [
        {
            step_id: 'explore_data_mapping_flows',
            navigate_to: '/admin/data-mapping/flows',
            target: '[data-testid="data-flows-page"] .dm-filters',
            wait_for: '[data-testid="data-flows-page"][data-tour-ready="true"]',
            title: 'Data Flows',
            title_vi: 'Luồng dữ liệu',
            description: 'Use the cross-border switch to isolate transfers that need a destination and safeguard review. Combine status and risk filters before comparing source and destination systems. A filter changes the displayed flows; it does not change their risk or transfer mechanism.',
            description_vi: 'Dùng công tắc xuyên biên giới để tách các luồng cần rà soát nơi nhận và biện pháp bảo vệ. Kết hợp bộ lọc trạng thái và rủi ro trước khi so sánh hệ thống nguồn và đích. Bộ lọc chỉ đổi danh sách hiển thị, không đổi mức rủi ro hay cơ chế chuyển dữ liệu.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'feature_flow_views',
            navigate_to: '/admin/data-mapping/flows',
            target: '[data-testid="data-flows-page"] .dm-header [role="tablist"]',
            wait_for: '[data-testid="data-flows-page"][data-tour-ready="true"]',
            title: 'List and Map Views',
            title_vi: 'Chế độ danh sách và bản đồ',
            description: 'Use List to compare flow records and Map to understand the connections between systems. The map identifies cross-border links and recorded risks; it is a view of stored relationships, not proof that a transfer is permitted. This walkthrough leaves the selected view unchanged.',
            description_vi: 'Dùng Danh sách để so sánh bản ghi luồng và Bản đồ để hiểu kết nối giữa các hệ thống. Bản đồ thể hiện liên kết xuyên biên giới và rủi ro đã ghi nhận, không xác nhận việc chuyển dữ liệu được phép. Hướng dẫn này giữ nguyên chế độ đang chọn.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'feature_flow_cross_border',
            navigate_to: '/admin/data-mapping/flows',
            target: '[data-testid="data-flows-page"] .dm-filters input[type="checkbox"]',
            wait_for: '[data-testid="data-flows-page"][data-tour-ready="true"]',
            title: 'Cross-Border Review Scope',
            title_vi: 'Phạm vi rà soát xuyên biên giới',
            description: 'This switch narrows the register to cross-border flows. For each matching flow, check source and destination countries and the recorded safeguard before following up in transfer assessments. A cross-border flag alone does not establish an adequate safeguard.',
            description_vi: 'Công tắc này thu hẹp sổ về các luồng xuyên biên giới. Với mỗi luồng phù hợp, kiểm tra quốc gia nguồn, quốc gia đích và biện pháp bảo vệ đã ghi trước khi theo dõi ở đánh giá chuyển dữ liệu. Dấu hiệu xuyên biên giới không tự xác nhận biện pháp bảo vệ là đầy đủ.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_data_mapping_systems',
            navigate_to: '/admin/data-mapping/systems',
            target: '[data-testid="data-systems-page"] .dm-filters',
            wait_for: '[data-testid="data-systems-page"][data-tour-ready="true"]',
            title: 'Systems',
            title_vi: 'Hệ thống',
            description: 'Compare the recorded owner, hosting location and criticality of each system.',
            description_vi: 'So sánh chủ sở hữu, nơi lưu trữ và mức độ quan trọng đã ghi của từng hệ thống.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_data_mapping_systems_register',
            navigate_to: '/admin/data-mapping/systems',
            target: '[data-tour-register="explore_data_mapping_systems_register"]',
            wait_for: '[data-testid="data-systems-page"][data-tour-ready="true"]',
            title: 'Systems — record decisions',
            title_vi: 'Hệ thống — quyết định theo bản ghi',
            description: 'Status and DPA status answer different questions: an active system can still need contractual follow-up. Use type and status filters to find the relevant records before tracing their processing activities.',
            description_vi: 'Trạng thái hệ thống và trạng thái DPA trả lời các câu hỏi khác nhau: hệ thống đang hoạt động vẫn có thể cần rà soát hợp đồng. Dùng bộ lọc loại và trạng thái để tìm bản ghi trước khi truy vết hoạt động xử lý.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_data_mapping_activities',
            navigate_to: '/admin/data-mapping/activities',
            target: '[data-testid="data-activities-page"] .dm-filters',
            wait_for: '[data-testid="data-activities-page"][data-tour-ready="true"]',
            title: 'Processing Activities',
            title_vi: 'Hoạt động xử lý',
            description: 'Use the filters to locate processing activities, then inspect the controller, lawful basis, status, recorded data tier and DPA/DPIA indicators.',
            description_vi: 'Dùng bộ lọc để tìm hoạt động xử lý, rồi xem bên kiểm soát, căn cứ pháp lý, trạng thái, cấp dữ liệu đã ghi và chỉ báo DPA/DPIA.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_data_mapping_activities_register',
            navigate_to: '/admin/data-mapping/activities',
            target: '[data-tour-register="explore_data_mapping_activities_register"]',
            wait_for: '[data-testid="data-activities-page"][data-tour-ready="true"]',
            title: 'Processing Activities — record decisions',
            title_vi: 'Hoạt động xử lý — quyết định theo bản ghi',
            description: 'These are recorded attributes, not proof that an assessment or agreement is complete. Follow the linked form or activity details to inspect supporting records.',
            description_vi: 'Đây là thuộc tính được ghi nhận, không phải xác nhận đánh giá hoặc thỏa thuận đã hoàn tất. Mở biểu mẫu liên kết hoặc chi tiết hoạt động để xem tài liệu liên quan.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_data_mapping_ropa_completeness',
            navigate_to: '/admin/data-mapping/ropa-completeness',
            target: ':is([data-tour-feature="tour-data-mapping-ropa-completeness"], [data-tour-feature="ropa-unavailable-framework"])',
            wait_for: '[data-testid="data-ropa-completeness-page"][data-tour-ready="true"]',
            title: 'ROPA Completeness',
            title_vi: 'Tính đầy đủ ROPA',
            description: 'Choose an installed framework to understand which required-field checks were evaluated. The report separates scored activities, evaluated severity tiers and missing-field drilldown. A zero for an evaluated tier differs from a tier that was not evaluated; no installed framework or no applicable rules cannot establish complete records.',
            description_vi: 'Chọn khung tuân thủ đã cài để biết các kiểm tra trường bắt buộc nào được đánh giá. Báo cáo tách số hoạt động được chấm, các mức độ nghiêm trọng được đánh giá và danh sách trường còn thiếu. Giá trị không ở mức đã đánh giá khác với mức chưa được đánh giá; chưa cài khung hoặc chưa có quy tắc áp dụng không xác nhận hồ sơ đầy đủ.',
            position: 'bottom',
            duration_ms: 19000,
        },
        {
            step_id: 'explore_data_mapping_categories',
            navigate_to: '/admin/data-mapping/categories',
            target: '[data-testid="data-categories-page"] .dm-filters',
            wait_for: '[data-testid="data-categories-page"][data-tour-ready="true"]',
            title: 'Data Categories',
            title_vi: 'Danh mục Dữ liệu',
            description: 'Compare sensitivity, status, examples and item counts before choosing a category for a registry element.',
            description_vi: 'So sánh độ nhạy cảm, trạng thái, ví dụ và số phần tử trước khi chọn danh mục cho phần tử dữ liệu.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_data_mapping_categories_register',
            navigate_to: '/admin/data-mapping/categories',
            target: '[data-tour-register="explore_data_mapping_categories_register"]',
            wait_for: '[data-testid="data-categories-page"][data-tour-ready="true"]',
            title: 'Data Categories — record decisions',
            title_vi: 'Danh mục Dữ liệu — quyết định theo bản ghi',
            description: 'A default designation is a reusable configuration choice, while approval records a separate decision. Category changes and approvals require their own permissions and are not performed here.',
            description_vi: 'Chỉ định mặc định là lựa chọn cấu hình dùng lại; phê duyệt là quyết định riêng. Việc sửa và phê duyệt danh mục cần quyền tương ứng và không được thực hiện trong bước này.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_data_mapping_registry',
            navigate_to: '/admin/data-mapping/registry',
            target: '[data-testid="data-registry-page"] .dm-filters',
            wait_for: '[data-testid="data-registry-page"][data-tour-ready="true"]',
            title: 'Data Registry',
            title_vi: 'Đăng ký Dữ liệu',
            description: 'The registry connects individual data elements to categories, data subjects, systems and processing activities. Compare sensitivity, recorded tier and status rather than treating these as interchangeable labels. A missing friendly scheme name can mean the optional classification catalogue was unavailable; it does not erase the stored classification code.',
            description_vi: 'Sổ dữ liệu liên kết từng phần tử với danh mục, chủ thể dữ liệu, hệ thống và hoạt động xử lý. So sánh độ nhạy cảm, cấp đã ghi và trạng thái thay vì coi chúng là cùng một nhãn. Tên sơ đồ chưa hiển thị có thể do danh mục phân loại tùy chọn không truy cập được; mã phân loại đã lưu vẫn còn.',
            position: 'bottom',
            duration_ms: 20000,
        },
        {
            step_id: 'explore_data_mapping_purposes',
            navigate_to: '/admin/data-mapping/purposes',
            target: '[data-testid="data-purposes-page"] .dm-filters',
            wait_for: '[data-testid="data-purposes-page"][data-tour-ready="true"]',
            title: 'Processing Purposes',
            title_vi: 'Mục đích Xử lý',
            description: 'Read the purpose description alongside its recorded lawful basis.',
            description_vi: 'Đọc mô tả mục đích cùng căn cứ pháp lý đã ghi.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_data_mapping_purposes_register',
            navigate_to: '/admin/data-mapping/purposes',
            target: '[data-tour-register="explore_data_mapping_purposes_register"]',
            wait_for: '[data-testid="data-purposes-page"][data-tour-ready="true"]',
            title: 'Processing Purposes — record decisions',
            title_vi: 'Mục đích Xử lý — quyết định theo bản ghi',
            description: 'A default purpose helps reuse a definition; it does not establish that the same basis applies to every activity. Review the actual processing context before reusing a purpose or changing its basis.',
            description_vi: 'Mục đích mặc định giúp dùng lại định nghĩa, không xác nhận cùng căn cứ phù hợp với mọi hoạt động. Rà soát bối cảnh xử lý thực tế trước khi dùng lại mục đích hoặc đổi căn cứ.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_data_mapping_retention',
            navigate_to: '/admin/data-mapping/retention',
            target: '[data-tour-feature="tour-data-mapping-retention"]',
            wait_for: '[data-testid="data-retention-page"][data-tour-ready="true"]',
            title: 'Retention',
            title_vi: 'Lưu trữ',
            description: 'Compare retention days, review frequency, disposal method and review status. Retention sets the recorded duration; review frequency schedules reconsideration, and neither proves disposal occurred. Check the affected processing records before proposing a change; this walkthrough changes no policy.',
            description_vi: 'So sánh số ngày lưu giữ, tần suất rà soát, phương thức tiêu hủy và trạng thái rà soát. Thời hạn lưu giữ ghi nhận khoảng thời gian; tần suất rà soát lên lịch xem xét lại, và cả hai không chứng minh việc tiêu hủy đã xảy ra. Kiểm tra hồ sơ xử lý liên quan trước khi đề xuất sửa; hướng dẫn không thay đổi chính sách.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_data_mapping_review',
            navigate_to: '/admin/data-mapping/review',
            target: '[data-testid="data-review-page"] .dm-filters',
            wait_for: '[data-testid="data-review-page"][data-tour-ready="true"]',
            title: 'Review Tasks',
            title_vi: 'Nhiệm vụ đánh giá',
            description: 'Find review tasks by category, owner and status.',
            description_vi: 'Tìm nhiệm vụ rà soát theo danh mục, người phụ trách và trạng thái.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_data_mapping_review_register',
            navigate_to: '/admin/data-mapping/review',
            target: '[data-tour-register="explore_data_mapping_review_register"]',
            wait_for: '[data-testid="data-review-page"][data-tour-ready="true"]',
            title: 'Review Tasks — record decisions',
            title_vi: 'Nhiệm vụ đánh giá — quyết định theo bản ghi',
            description: 'A pending task needs a recorded review decision; viewing it does not approve the category. Task updates and category approval use separate permissions, so investigate the linked record before deciding which action is appropriate.',
            description_vi: 'Nhiệm vụ đang chờ cần quyết định rà soát được ghi nhận; xem nhiệm vụ không phê duyệt danh mục. Cập nhật nhiệm vụ và phê duyệt danh mục dùng quyền riêng, vì vậy cần xem bản ghi liên kết trước khi chọn hành động.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_data_mapping_inventory',
            navigate_to: '/admin/data-mapping/inventory',
            target: '[data-tour-feature="tour-data-mapping-inventory"]',
            wait_for: '[data-testid="data-inventory-page"][data-tour-ready="true"]',
            title: 'Inventory',
            title_vi: 'Kho dữ liệu',
            description: 'Read each system with its total, approved and pending label counts and last update. Approved and pending labels describe different review states; a total alone cannot show that classification review is complete. An empty successful register reports no matching inventory rows, not complete discovery coverage.',
            description_vi: 'Xem từng hệ thống cùng tổng số nhãn, số đã phê duyệt, số đang chờ và lần cập nhật cuối. Nhãn đã phê duyệt và đang chờ thể hiện trạng thái rà soát khác nhau; chỉ tổng số không xác nhận việc rà soát đã xong. Sổ trống sau khi tải thành công chỉ cho biết không có dòng phù hợp, không xác nhận đã khám phá toàn bộ dữ liệu.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_data_mapping_exceptions',
            navigate_to: '/admin/data-mapping/exceptions',
            target: '[data-testid="data-exceptions-page"] .dm-filters',
            wait_for: '[data-testid="data-exceptions-page"][data-tour-ready="true"]',
            title: 'Exceptions',
            title_vi: 'Ngoại lệ',
            description: 'Combine severity and status to identify classification exceptions needing attention.',
            description_vi: 'Kết hợp mức độ nghiêm trọng và trạng thái để tìm ngoại lệ phân loại cần xử lý.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_data_mapping_exceptions_register',
            navigate_to: '/admin/data-mapping/exceptions',
            target: '[data-tour-register="explore_data_mapping_exceptions_register"]',
            wait_for: '[data-testid="data-exceptions-page"][data-tour-ready="true"]',
            title: 'Exceptions — record decisions',
            title_vi: 'Ngoại lệ — quyết định theo bản ghi',
            description: 'Read the affected system, description and creation date before considering a resolution. Resolving an exception is a separate recorded decision; narrowing the queue does not remove the underlying issue.',
            description_vi: 'Đọc hệ thống bị ảnh hưởng, mô tả và ngày tạo trước khi cân nhắc giải quyết. Giải quyết ngoại lệ là quyết định riêng được ghi nhận; thu hẹp hàng đợi không xóa vấn đề gốc.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_data_mapping_history',
            navigate_to: '/admin/data-mapping/history',
            target: '[data-tour-feature="tour-data-mapping-history"]',
            wait_for: '[data-testid="data-history-page"][data-tour-ready="true"]',
            title: 'History',
            title_vi: 'Lịch sử',
            description: 'Use date, actor, action and entity type to trace a classification change. The change summary says what was recorded; inspect available details for its context. An empty history does not prove that the inventory was never changed outside this recorded stream.',
            description_vi: 'Dùng ngày, người thực hiện, hành động và loại thực thể để truy vết thay đổi phân loại. Tóm tắt cho biết nội dung được ghi; xem chi tiết có sẵn để hiểu bối cảnh. Lịch sử trống không chứng minh danh mục chưa từng thay đổi bên ngoài luồng ghi nhận này.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_regulatory_classification',
            navigate_to: '/admin/regulatory-classification',
            target: '[data-tour-feature="tour-regulatory-classification"]',
            wait_for: '[data-testid="regulatory-classification-page"][data-tour-ready="true"]',
            title: 'Subject Register',
            title_vi: 'Sổ đăng ký đối tượng phân loại',
            description: 'Compare subject kind, installed scheme, recorded tier, tier source and status in the register. Classifications belong to a specific scheme and version, so a tier name alone is insufficient context. Protective-measure tests and transitional windows are read in a selected subject profile, not in this list; a declared status is not evidence that a measure was tested.',
            description_vi: 'So sánh loại đối tượng, sơ đồ đã cài, cấp đã ghi, nguồn xác định cấp và trạng thái trong sổ. Phân loại gắn với sơ đồ và phiên bản cụ thể, nên chỉ tên cấp chưa đủ bối cảnh. Kiểm tra biện pháp bảo vệ và cửa sổ chuyển tiếp nằm trong hồ sơ đối tượng được chọn, không phải danh sách này; trạng thái khai báo không chứng minh biện pháp đã được kiểm tra.',
            position: 'bottom',
            duration_ms: 23000,
        },
        {
            step_id: 'explore_regulatory_classification_offerings',
            navigate_to: '/admin/regulatory-classification/offerings',
            target: '[data-tour-feature="tour-regulatory-classification-offerings"]',
            wait_for: '[data-testid="regulatory-classification-offerings-page"][data-tour-ready="true"]',
            title: 'Regulated Offerings',
            title_vi: 'Sản phẩm, dịch vụ được quản lý',
            description: 'Use kind and status to locate a data product, service or exchange listing. Inspect its obligation links and provenance before interpreting its standing. A registered offering records the organisation’s information; it is not an external authorisation or a completed obligation.',
            description_vi: 'Dùng loại và trạng thái để tìm sản phẩm, dịch vụ hoặc mục trao đổi dữ liệu. Xem liên kết nghĩa vụ và nguồn gốc trước khi diễn giải tình trạng. Mục đã đăng ký ghi nhận thông tin của tổ chức, không phải giấy phép bên ngoài hoặc xác nhận nghĩa vụ đã hoàn thành.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_data_mapping_governance',
            navigate_to: '/admin/data-mapping/governance',
            target: '[data-testid="data-governance-page"] .dm-filters',
            wait_for: '[data-testid="data-governance-page"][data-tour-ready="true"]',
            title: 'Governance',
            title_vi: 'Quản trị',
            description: 'Compare entity type, governance role, assignee and department.',
            description_vi: 'So sánh loại thực thể, vai trò quản trị, người được giao và phòng ban.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_data_mapping_governance_register',
            navigate_to: '/admin/data-mapping/governance',
            target: '[data-tour-register="explore_data_mapping_governance_register"]',
            wait_for: '[data-testid="data-governance-page"][data-tour-ready="true"]',
            title: 'Governance — record decisions',
            title_vi: 'Quản trị — quyết định theo bản ghi',
            description: 'These assignments record responsibility for data governance, not technical access permissions. Check who is accountable for the actual record before requesting attestation or resolving an ownership gap.',
            description_vi: 'Các phân công ghi nhận trách nhiệm quản trị dữ liệu, không phải quyền truy cập kỹ thuật. Kiểm tra người chịu trách nhiệm cho bản ghi trước khi yêu cầu xác nhận hoặc xử lý khoảng trống sở hữu.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_data_mapping_attestation',
            navigate_to: '/admin/data-mapping/attestation',
            target: '[data-testid="data-attestation-page"] .dm-filters',
            wait_for: '[data-testid="data-attestation-page"][data-tour-ready="true"]',
            title: 'Attestation Cycles',
            title_vi: 'Chu kỳ chứng thực',
            description: 'Use year, deadline, scope and status to identify the relevant attestation cycle.',
            description_vi: 'Dùng năm, hạn, phạm vi và trạng thái để xác định kỳ xác nhận phù hợp.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_data_mapping_attestation_register',
            navigate_to: '/admin/data-mapping/attestation',
            target: '[data-tour-register="explore_data_mapping_attestation_register"]',
            wait_for: '[data-testid="data-attestation-page"][data-tour-ready="true"]',
            title: 'Attestation Cycles — record decisions',
            title_vi: 'Chu kỳ chứng thực — quyết định theo bản ghi',
            description: 'A cycle status summarizes work; task progress and stale entries are read in its available details. Review outstanding department inputs before treating the cycle as ready for sign-off.',
            description_vi: 'Trạng thái kỳ tóm tắt công việc; tiến độ nhiệm vụ và mục cũ được xem trong chi tiết có sẵn. Rà soát đầu vào phòng ban còn thiếu trước khi coi kỳ đã sẵn sàng xác nhận.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_data_mapping_evidence',
            navigate_to: '/admin/data-mapping/evidence',
            target: '[data-testid="data-evidence-page"] .dm-filters',
            wait_for: '[data-testid="data-evidence-page"][data-tour-ready="true"]',
            title: 'Evidence',
            title_vi: 'Bằng chứng',
            description: 'Compare evidence type, linked entities, tags, uploaded date and expiry.',
            description_vi: 'So sánh loại tài liệu chứng minh, thực thể liên kết, thẻ, ngày tải lên và hạn hết hiệu lực.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_data_mapping_evidence_register',
            navigate_to: '/admin/data-mapping/evidence',
            target: '[data-tour-register="explore_data_mapping_evidence_register"]',
            wait_for: '[data-testid="data-evidence-page"][data-tour-ready="true"]',
            title: 'Evidence — record decisions',
            title_vi: 'Bằng chứng — quyết định theo bản ghi',
            description: 'A file’s presence does not establish that it is current or supports the record being reviewed. Follow the correct entity relationship before using evidence in attestation or an export.',
            description_vi: 'Có tệp không xác nhận tệp còn phù hợp hoặc chứng minh cho bản ghi đang rà soát. Theo đúng liên kết thực thể trước khi dùng tài liệu trong xác nhận hoặc xuất hồ sơ.',
            position: 'bottom',
            duration_ms: 18000,
        },
        {
            step_id: 'explore_data_mapping_exports',
            navigate_to: '/admin/data-mapping/exports',
            target: '[data-tour-feature="tour-data-mapping-exports"]',
            wait_for: '[data-testid="data-exports-page"][data-tour-ready="true"]',
            title: 'Exports',
            title_vi: 'Xuất dữ liệu',
            description: 'The export table names each available entity, its scope and supported formats. Choose the evidence purpose before selecting a format: an exported register reflects recorded data, not an authority’s acceptance. Export controls require the separate export grant; this tour neither generates nor downloads files.',
            description_vi: 'Bảng xuất nêu từng thực thể, phạm vi và định dạng được hỗ trợ. Xác định mục đích tài liệu trước khi chọn định dạng: sổ được xuất phản ánh dữ liệu đã ghi, không phải sự chấp nhận của cơ quan. Điều khiển xuất cần quyền riêng; hướng dẫn không tạo hoặc tải tệp.',
            position: 'bottom',
            duration_ms: 18000,
        },
    ],
};
//# sourceMappingURL=data-mapping.js.map